(function(){
  if (window.__mmMotion) return; window.__mmMotion = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var style = document.createElement('style');
  style.textContent = '.mm-will-reveal{opacity:0;transform:translateY(28px);transition:opacity .8s cubic-bezier(.22,.61,.36,1),transform .8s cubic-bezier(.22,.61,.36,1)}'+
    '.mm-revealed{opacity:1;transform:none}';
  document.head.appendChild(style);
  function arm(){
    var targets = document.querySelectorAll('.mm-story__row, .mm-room__item, .mm-compare, .mm-guarantee__item, .mm-tile, .mm-hero__content');
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('mm-revealed'); io.unobserve(e.target); } });
    }, {threshold: 0.12});
    targets.forEach(function(t, i){
      var r = t.getBoundingClientRect();
      if (r.top < window.innerHeight) { return; } // already on screen: never hide
      t.classList.add('mm-will-reveal');
      t.style.transitionDelay = (i % 3) * 70 + 'ms';
      io.observe(t);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
})();
